export interface AgeChartSegment {
    label: string;
    percentage: number;
    color: string;
}

export interface AgeChartItem {
    label: string;
    segments: AgeChartSegment[];
}

const GENDERS: AgeChartSegment[] = [
    { label: 'female', percentage: 0, color: '#E794F8' },
    { label: 'male', percentage: 0, color: '#5AC8FF' },
    { label: 'other', percentage: 0, color: '#FFA500' },
];

const AGE_RANGES = [
    '18 a 20 años',
    '21 a 23 años',
    '24 a 26 años',
    '27 a 30 años',
    '31 a 35 años',
    '+36 años',
];

export function generateEmptyAgeChartItems(): AgeChartItem[] {
    return AGE_RANGES.map((label) => ({
        label,
        segments: GENDERS.map((g) => ({ ...g })),
    }));
}
